export enum CommitType {
  CREATE_ENTRY,
  UPDATE_FIELD,
  DELETE_ENTRY,
  ARCHIVE_ENTRY,
  UNARCHIVE_ENTRY,
}
